@import "../common-input";


:host(.form-field) {
  margin-bottom: v(--spacing-07);
}
